import { authRoleAccess } from "auth/AuthRoleAccess";
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import SpatialTrackingOutlinedIcon from '@mui/icons-material/SpatialTrackingOutlined';
export const navigationItems = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.dashborad,
  },
  {
    title: 'Incidents',
    icon: <WarningAmberOutlinedIcon />,
    submenu: [
      {
        title: 'Incidents',
        path: '/incidents',
        roles: authRoleAccess.all_incidents_view,
      },
      {
        title: 'Create Incident',
        path: '/create_incidents',
        roles: authRoleAccess.all_incidents_view,
      },
      {
        title: 'My Assigned Tasks',
        path: '/my_assigned_tasks',
        roles: authRoleAccess.my_assigned_tasks_view,
      }
    ],

  },
  {
    title: 'Audits',
    icon: <VerifiedUserOutlinedIcon />,
    submenu: [
      {
        title: 'Create',
        path: '/create_audit',
        roles: authRoleAccess.audit_create,
      },
      {
        title: 'Audit Forms',
        path: '/audits',
        roles: authRoleAccess.audit_create,
      },
      {
        title: 'My Audits',
        path: '/NewAllAssignAuditView',
        roles: authRoleAccess.audit_create,
      },

    ],

  },
  {
    title: 'Risk Assessment',
    icon: <GppMaybeOutlinedIcon />,
    path: '/risk_assessment',
    roles: authRoleAccess.risk_assessment,

  },
  {
    title: 'User Management',
    icon: <ManageAccountsOutlinedIcon />,
    path: '/users',
    roles: authRoleAccess.user_management,

  },

  {
    title: 'Data Setups',
    icon: <SettingsOutlinedIcon />,
    submenu: [

      {
        title: 'Company Profile',
        path: '/company_profile',
        roles: authRoleAccess.company_profile,
      },
      {
        title: 'Branch',
        path: '/branches',
        roles: authRoleAccess.company_dataSetup,
      },
      {
        title: 'Departments',
        path: '/departments',
        roles: authRoleAccess.company_dataSetup,
      },
      {
        title: 'Locations',
        path: '/locations',
        roles: authRoleAccess.company_dataSetup,
      },
      {
        title: 'Sub Locations',
        path: '/sub_locations',
        roles: authRoleAccess.company_dataSetup,
      },
      {
        title: 'Incident Types',
        path: '/incident_types',
        roles: authRoleAccess.incidet_type_setup,
      },
      {
        title: 'Severity Impacts',
        path: '/severity_impacts',
        roles: authRoleAccess.incidet_type_setup,
      },
      {
        title: 'Designations',
        path: '/designations',
        roles: authRoleAccess.company_dataSetup,
      },

    ],

  },
  {
    title: 'Risk Data Setups',
    icon: <SettingsOutlinedIcon />,
    submenu: [

      {
        title: 'Hazard Group',
        path: '/hazard_groups',
        roles: authRoleAccess.company_risk_assesment_dataSetup,
      },
      {
        title: 'Hazard',
        path: '/hazard',
        roles: authRoleAccess.company_risk_assesment_dataSetup,
      },
      {
        title: 'Risk Task',
        path: '/risk_task',
        roles: authRoleAccess.company_risk_assesment_dataSetup,
      },
      {
        title: 'Risk Controllers',
        path: '/risk_controllers',
        roles: authRoleAccess.company_risk_assesment_dataSetup,
      },


    ],

  },
  {
    title: 'Training',
    icon: <SpatialTrackingOutlinedIcon />,
    submenu: [
      {
        title: 'Training Setups',
        path: '/training_setups',
        roles: authRoleAccess.trainingSetups,
      },
    
    ]
  },
  {
    title: 'Training Data Setups',
    icon: <SettingsOutlinedIcon />,
    submenu: [
      {
        title: 'Training Categories',
        path: '/training_categories',
        roles: authRoleAccess.trainingCategorySetup,
      },
      {
        title: 'Training Teams',
        path: '/training_teams',
        roles: authRoleAccess.trainingTeamSetup,
      }
    ]
  }
  /* {
    title: 'Documentation',
    path: '/themes/examples',
    icon: <GridViewOutlinedIcon />,
    roles: authRoleAccess.themeExamples,
  }, */

]; 